/**
 * Get part of a sentence and the url page to tweet it
 */
export default function initGetTwitterContent() {
  const els = document.querySelectorAll('.twit');

  els.forEach((element) => {
    element.addEventListener('click', () => {
      if (element.parentElement.parentElement.localName === 'blockquote' || element.parentElement.localName === 'blockquote') {
        const customtwit = document.getElementById('custom-twit');
        if (customtwit != null) {
          const elContent = customtwit.innerHTML;
          // eslint-disable-next-line no-param-reassign
          element.href = `https://twitter.com/share?text=${encodeURIComponent(elContent).replaceAll('%26nbsp%3B', '')} &url=${window.location.href}`;
        } else {
          const elContent = element.innerHTML;
          /* eslint-disable */
          element.href = `https://twitter.com/share?text=${encodeURIComponent(elContent).replaceAll('%26nbsp%3B', '')} &url=${window.location.href}`;
        }
      } else {
        const elContent = element.innerHTML;
        /* eslint-disable */
        element.href = `https://twitter.com/share?text=${encodeURIComponent(elContent).replaceAll('%26nbsp%3B', '')} &url=${window.location.href}`;
      }
    })
  })
}
